var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _path14, _g4, _path15, _g5, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9475 14.8277L68.5887 13.2869C70.6577 12.1424 72.5506 11.9223 74.0033 12.6707L76.6445 14.1674L75.588 14.2114C75.8522 14.6516 76.0282 15.0918 76.1603 15.6201C74.4435 15.7081 72.7707 16.0162 72.0223 17.2048C71.8463 17.0727 71.6702 16.9407 71.4941 16.8526L68.5447 20.2423L65.9475 18.7896V14.8277Z",
    fill: "url(#paint0_linear_1235:43292)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4167 34.6802C67.7498 33.3156 69.9068 30.4982 70.8753 27.5048L72.6361 22.1342C73.2524 20.1533 73.1644 18.4805 72.328 17.468C72.2399 17.38 72.1519 17.2919 72.0639 17.2039C72.7682 16.0594 74.485 15.7072 76.2018 15.6191C76.6861 17.336 76.51 19.581 75.7616 22.0022L74.3529 26.3602L74.8372 27.0206C74.8372 27.0206 71.5356 35.3845 71.3595 35.4726C71.2275 35.5606 69.7307 35.8688 68.7183 36.0449C67.7058 37.1014 66.5612 37.9818 65.4167 38.6421L57.1848 43.3963V46.3458L54.5875 44.8931V40.9312L65.4167 34.6802Z",
    fill: "url(#paint1_linear_1235:43292)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0149 36.1347C70.348 34.7701 72.505 31.9527 73.4735 28.9593L75.2343 23.5887C75.8066 21.6078 75.7186 19.935 74.8822 18.9225C74.0458 17.91 72.7251 17.822 71.1844 18.7024L68.5431 20.2432V16.2813L71.1844 14.7405C73.8697 13.1998 76.3349 13.3319 77.7875 15.0927C79.2402 16.8535 79.4163 19.979 78.3158 23.4127L76.555 28.7832C75.0142 33.5375 71.6686 37.9836 68.0149 40.0966L57.1857 46.3476V42.3857L68.0149 36.1347Z",
    fill: "url(#paint2_linear_1235:43292)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1235:43292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.692 89.4898C41.7133 89.4898 34.4347 87.6181 34.4347 85.3093C34.4347 83.0006 41.7133 81.1289 50.692 81.1289C59.6706 81.1289 66.9492 83.0006 66.9492 85.3093C66.9492 87.6181 59.6706 89.4898 50.692 89.4898Z",
    fill: "url(#paint3_linear_1235:43292)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7966 71.0883L36.8026 71.1323C37.1107 70.9122 37.4188 70.7361 37.727 70.5601C44.2861 66.7743 54.9392 66.7743 61.5423 70.5601C61.9385 70.7802 62.3347 71.0443 62.6869 71.3084L66.4727 71.3524V77.4714C66.4727 79.9365 64.8439 82.4457 61.5423 84.3386C54.9832 88.1244 44.3301 88.1244 37.727 84.3386C34.4254 82.4457 32.7966 79.9365 32.7966 77.4714V71.0883V71.0883Z",
    fill: "url(#paint4_linear_1235:43292)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6567 80.8166C40.3694 80.8166 32.8407 76.461 32.8407 71.088C32.8407 65.715 40.3694 61.3594 49.6567 61.3594C58.9439 61.3594 66.4727 65.715 66.4727 71.088C66.4727 76.461 58.9439 80.8166 49.6567 80.8166Z",
    fill: "url(#paint5_linear_1235:43292)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1235:43292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7258 77.9546C44.285 81.7404 54.938 81.7404 61.5412 77.9546C64.6666 76.1497 66.2954 73.8166 66.4715 71.4395C66.6476 74.0367 65.0188 76.6779 61.5412 78.7029C54.982 82.4887 44.329 82.4887 37.7258 78.7029C34.2922 76.722 32.6194 74.0807 32.7955 71.4395C32.9716 73.8166 34.6004 76.1497 37.7258 77.9546Z",
    fill: "url(#paint6_linear_1235:43292)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3296 68.4479C40.5497 68.3159 40.7698 68.1838 40.9899 68.0077C43.7936 66.3723 47.6382 65.7013 51.296 65.9947C53.8546 66.1893 56.3173 66.8697 58.2897 68.0076C58.5978 68.1837 58.8619 68.3598 59.1261 68.5359H60.1826V74.2146C59.6543 74.6988 59.038 75.183 58.2897 75.6232C57.5025 76.0773 56.6374 76.4534 55.7191 76.7549C51.0548 78.3235 44.9722 77.9464 40.9899 75.6233C38.6128 74.2587 37.4242 72.4538 37.4242 70.649V68.4039L40.3296 68.4479ZM61.8555 68.5351H60.1827V74.2138C61.2832 73.1132 61.8555 71.8807 61.8555 70.6481V68.5351Z",
    fill: "url(#paint7_linear_1235:43292)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6617 75.4461C42.9272 75.4461 37.4679 72.2927 37.4679 68.4027C37.4679 64.5128 42.9272 61.3594 49.6617 61.3594C56.3961 61.3594 61.8555 64.5128 61.8555 68.4027C61.8555 72.2927 56.3961 75.4461 49.6617 75.4461Z",
    fill: "url(#paint8_linear_1235:43292)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1716 62.637C52.5619 64.706 46.7071 64.706 43.0974 62.637C39.4877 60.568 39.4877 57.1784 43.0974 55.0654C46.7071 52.9964 52.5619 52.9964 56.1716 55.0654C59.7813 57.1784 59.7813 60.568 56.1716 62.637Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4494 64.2207C58.5125 62.768 58.8647 61.3594 58.8647 61.3594L57.412 63.1202C52.9219 60.9632 46.3628 60.9632 41.9166 63.1202L40.4199 61.3594C40.4199 61.3594 40.8161 62.768 38.8352 64.2207C36.8983 65.6734 37.5145 68.4908 37.5145 68.4908C37.5145 70.2956 38.7031 72.0565 41.0802 73.4211C45.7905 76.1504 53.4941 76.1504 58.2044 73.4211C60.5815 72.0565 61.7701 70.2516 61.7701 68.4908C61.7701 68.4908 62.3864 65.6734 60.4494 64.2207Z",
    fill: "url(#paint9_linear_1235:43292)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1716 64.7913C52.5619 66.8603 46.7071 66.8603 43.0974 64.7913C39.4877 62.7223 39.4877 59.3327 43.0974 57.2197C46.7071 55.1507 52.5619 55.1507 56.1716 57.2197C59.7813 59.3327 59.7813 62.6783 56.1716 64.7913Z",
    fill: "url(#paint10_linear_1235:43292)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4491 24.9551C25.7133 38.4255 32.6245 40.0543 36.3663 45.1167C39.844 49.8269 39.4478 56.6501 39.3597 57.5306C39.3597 57.5746 39.3597 57.6186 39.3597 57.6186C39.3597 59.1593 40.3722 60.656 42.3532 61.8006C46.3591 64.1337 52.8742 64.1337 56.8801 61.8006C58.773 60.7001 59.7414 59.2914 59.8735 57.8827H59.9175V57.6186C59.9175 57.5746 59.9175 57.5746 59.9175 57.5306C59.8295 56.6501 59.4333 49.8269 62.9109 45.1167C66.6087 40.0543 73.564 38.4255 73.8281 24.9551H25.4491V24.9551Z",
    fill: "url(#paint11_linear_1235:43292)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1025 39.657C43.1025 39.657 43.6748 41.2858 45.4356 45.864C47.1965 50.4862 46.3601 62.1517 46.3601 62.1517L43.3667 62.3718C43.0145 62.1957 42.6623 62.0637 42.3542 61.8436C40.3292 60.699 39.3608 59.1583 39.3608 57.6616C39.3608 57.6176 39.3608 57.5735 39.3608 57.5735C39.4488 56.6931 39.845 49.8699 36.3673 45.1596C32.6696 40.0972 25.7143 38.4685 25.4501 24.998H28.0914L43.1025 39.657Z",
    fill: "url(#paint12_linear_1235:43292)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6596 38.9093C36.2879 38.9093 25.4481 32.6616 25.4481 24.9546C25.4481 17.2477 36.2879 11 49.6596 11C63.0312 11 73.8711 17.2477 73.8711 24.9546C73.8711 32.6616 63.0312 38.9093 49.6596 38.9093Z",
    fill: "url(#paint13_linear_1235:43292)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1235:43292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7387 34.8596C57.2742 40.3182 41.9549 40.3182 32.5344 34.8596C28.0883 32.3064 25.7112 28.9608 25.4911 25.6152C25.227 29.401 27.5601 33.2309 32.5344 36.0922C41.9989 41.5508 57.3182 41.5508 66.7387 36.0922C71.7131 33.2309 74.0902 29.357 73.7821 25.6152C73.562 28.9608 71.1848 32.2624 66.7387 34.8596Z",
    fill: "url(#paint14_linear_1235:43292)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6595 36.6633C38.4516 36.6633 29.3658 31.4207 29.3658 24.9537C29.3658 18.4867 38.4516 13.2441 49.6595 13.2441C60.8674 13.2441 69.9531 18.4867 69.9531 24.9537C69.9531 31.4207 60.8674 36.6633 49.6595 36.6633Z",
    fill: "url(#paint15_linear_1235:43292)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1235:43292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2658 17.7343C43.1896 13.1561 56.0437 13.1561 63.9675 17.7343C67.7092 19.8913 69.6902 22.6646 69.9103 25.482C70.1744 22.3125 68.1935 19.0989 63.9675 16.6778C56.0437 12.0996 43.1896 12.0996 35.2658 16.6778C31.0838 19.0989 29.1029 22.3125 29.323 25.482C29.5871 22.6646 31.5681 19.8913 35.2658 17.7343Z",
    fill: "url(#paint16_linear_1235:43292)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7119 35.1668C45.8748 37.1478 53.4464 37.1478 59.6094 35.1668C59.3893 35.0348 59.1692 34.9027 58.9491 34.7706C53.8426 31.8212 45.5227 31.8212 40.3722 34.7706C40.1081 34.9027 39.888 35.0348 39.7119 35.1668Z",
    fill: "url(#paint17_linear_1235:43292)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1235:43292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.918 57.5293C59.918 57.4413 59.918 57.2212 59.8739 56.957C59.6979 58.3657 58.7294 59.6863 56.9245 60.7868C52.9186 63.12 46.4035 63.12 42.3976 60.7868C40.5928 59.7303 39.6243 58.4097 39.4042 57.0451C39.4042 57.2652 39.4042 57.4413 39.3602 57.5293C39.3602 57.5733 39.3602 57.6173 39.3602 57.6173C39.3602 59.1581 40.3727 60.6548 42.3536 61.7993C46.3595 64.1324 52.8746 64.1324 56.8805 61.7993C58.7734 60.6988 59.7419 59.2901 59.8739 57.8815H59.918V57.6173C59.918 57.6173 59.918 57.5733 59.918 57.5293Z",
    fill: "url(#paint18_linear_1235:43292)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8718 55.1988C28.9723 55.9032 30.5571 55.8151 32.2299 54.8467L43.059 48.5957L45.6562 50.0484L44.9079 51.325L43.059 51.8092V52.5136L32.2299 58.7645C30.9533 59.5129 29.7647 59.9091 28.6201 59.9971C27.0354 58.6325 27.2115 56.8716 27.8718 55.1988Z",
    fill: "url(#paint19_linear_1235:43292)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3507 43.3243C23.0205 43.9171 22.7194 44.5318 22.4524 45.1628C20.9997 48.5965 20.8236 51.898 21.9241 54.1431L23.685 57.4887C24.1252 58.3251 24.7415 58.9854 25.4458 59.4256L28.0431 60.8783L28.3512 60.0859H28.6593L28.4392 59.8658L28.6153 59.3816H28.0431C27.1186 58.105 27.3387 56.6083 27.911 55.1996C27.4708 54.8914 27.0746 54.4953 26.8105 53.967L25.0496 50.6214C24.7855 50.0491 24.6534 49.3888 24.6534 48.6405L25.4898 49.1247L30.5522 41.8612L34.1179 38.0314L34.25 37.107L31.6528 35.6543L29.0115 37.195C26.8545 38.4716 24.7855 40.6727 23.3328 43.3139L23.3507 43.3243Z",
    fill: "url(#paint20_linear_1235:43292)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8271 60.2624L45.6562 54.0115V50.0496L34.8271 56.3005C32.494 57.6652 30.337 57.313 29.3685 55.4201L27.6077 52.0745C26.9914 50.842 27.0794 49.0371 27.9158 47.0562C28.7522 45.1192 30.0728 43.4905 31.6136 42.61L34.2548 41.0693V37.1074L31.6136 38.6482C28.9283 40.1889 26.4631 43.1823 25.0545 46.6159C23.6018 50.0496 23.4257 53.3952 24.5262 55.5522L26.287 58.8978C27.7838 61.8472 31.1734 62.3754 34.8271 60.2624Z",
    fill: "url(#paint21_linear_1235:43292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1235:43292",
    x: 26.4336,
    y: 73.1289,
    width: 48.5156,
    height: 24.3613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1235:43292",
    x: 31.7812,
    y: 70.4395,
    width: 35.7031,
    height: 12.1035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1235:43292",
    x: 24.4727,
    y: 24.6152,
    width: 50.3359,
    height: 16.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1235:43292",
    x: 28.3047,
    y: 12.2441,
    width: 42.6289,
    height: 14.2383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43292"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1235:43292",
    x: 38.3594,
    y: 55.957,
    width: 22.5586,
    height: 8.5918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235:43292",
    x1: 70.039,
    y1: 13.8507,
    x2: 70.1602,
    y2: 18.8367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235:43292",
    x1: 62.9584,
    y1: 21.8209,
    x2: 63.8294,
    y2: 40.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235:43292",
    x1: 63.8538,
    y1: 21.2845,
    x2: 64.8982,
    y2: 34.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235:43292",
    x1: 55.6399,
    y1: 87.8768,
    x2: 54.6504,
    y2: 83.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1235:43292",
    x1: 62.2236,
    y1: 85.7478,
    x2: 39.7636,
    y2: 59.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1235:43292",
    x1: 56.4037,
    y1: 62.6814,
    x2: 54.3499,
    y2: 82.7827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265323,
    stopColor: "#69D7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529957,
    stopColor: "#13C0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1235:43292",
    x1: 49.6336,
    y1: 71.4395,
    x2: 49.6336,
    y2: 81.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1235:43292",
    x1: 58.7728,
    y1: 76.8378,
    x2: 45.7638,
    y2: 58.5901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1235:43292",
    x1: 58.7784,
    y1: 74.4106,
    x2: 42.5185,
    y2: 55.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1235:43292",
    x1: 58.7793,
    y1: 74.431,
    x2: 42.4957,
    y2: 55.3589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1235:43292",
    x1: 51.8435,
    y1: 63.0469,
    x2: 41.6237,
    y2: 54.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1235:43292",
    x1: 67.7239,
    y1: 60.7135,
    x2: 23.2321,
    y2: 23.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1235:43292",
    x1: 38.5263,
    y1: 50.8318,
    x2: 20.2901,
    y2: 45.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1235:43292",
    x1: 57.0284,
    y1: 33.525,
    x2: 50.9712,
    y2: 22.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1235:43292",
    x1: 49.6398,
    y1: 25.6152,
    x2: 49.6398,
    y2: 40.1862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1235:43292",
    x1: 64.832,
    y1: 34.9419,
    x2: 37.8044,
    y2: 3.27347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1235:43292",
    x1: 49.62,
    y1: 13.2441,
    x2: 49.62,
    y2: 25.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1235:43292",
    x1: 57.0988,
    y1: 36.3516,
    x2: 54.4337,
    y2: 27.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1235:43292",
    x1: 49.6391,
    y1: 56.957,
    x2: 49.6391,
    y2: 63.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1235:43292",
    x1: 34.3767,
    y1: 50.8969,
    x2: 34.5206,
    y2: 57.9971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1235:43292",
    x1: 26.1993,
    y1: 40.7455,
    x2: 27.1828,
    y2: 56.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22F4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1235:43292",
    x1: 30.4827,
    y1: 42.8007,
    x2: 31.0683,
    y2: 53.0557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRewards);
export default __webpack_public_path__ + "static/media/total-rewards.49f8b2b7.svg";
export { ForwardRef as ReactComponent };